module.exports = __webpack_public_path__ + "img/monitor.498bd556.svg";